module.exports = __webpack_public_path__ + "officialStatic/img/n8.2386e3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/n8.jpg
// module id = Hesl
// module chunks = 0